var map = {
	"./modalCovilha.template.tsx": 591,
	"./modalDetalhada.template.tsx": 353,
	"./modalExpo.template.tsx": 355,
	"./modalGaleria.template.tsx": 357,
	"./modalTexto.template.tsx": 359,
	"./modalVideo.template.tsx": 361,
	"./modalVideoGaleria.template.tsx": 363,
	"./modalViewer3d.template.tsx": 581
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 351;